import { Pipe } from '@angular/core';

// Tell Angular2 we're creating a Pipe with TypeScript decorators
@Pipe({
    name: 'feedPipe'
})
export class FeedPipe {
    // Transform is the new "return function(value, args)" in Angular 1.x
    transform(value, args?) {
        // ES6 array destructuring
        let val;
        let str;
        let content;
        let title;
        if (args) {
            args = args.toLowerCase();
            return value.filter(feed => {
                title = feed.title.toString().toLowerCase();
                content = feed.content.toString().toLowerCase();
                if (title.indexOf(args) >= 0) {
                    return feed;
                }
                if (content.indexOf(args) >= 0) {
                    return feed;
                }
            });
        }
        else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/feed/feed.search.ts